// Memorial entry for Aryeh Zalmanovich
import aryehZalmanovichPortrait from '../../../images/aryeh-zalmanovich.jpg';

export const aryehZalmanovichMemorial = {
  id: 27,
  name: 'Aryeh Zalmanovich',
  images: {
    portrait: aryehZalmanovichPortrait
  },
  info: `
"For 60 years, he got up every day at 4:30 a.m. and went out to plow, sow and harvest. He refused to leave the kibbutz." - His son Boaz

# Aryeh Zalmanovich

![Aryeh Zalmanovich](${aryehZalmanovichPortrait})
*Aryeh "Zalman" Zalmanovich, founding father of Kibbutz Nir Oz*

## A Life Rooted in the Land

Aryeh Zalmanovich was 85 years old when Hamas terrorists tore him from the kibbutz he had spent his entire adult life building. Born in Haifa, he joined the Hashomer Hatzair youth movement as a teenager and in 1955 became one of the founding members of Kibbutz Nir Oz through the Nahal military-agricultural program.

For nearly seven decades, Aryeh was inseparable from the land. He woke at 4:30 a.m. every day for 60 years to work the fields - growing wheat, potatoes, peanuts, and sunflowers in the harsh Negev desert. Even in the driest years when there was nothing to harvest, even when rockets gave him only 10 seconds to reach shelter, he refused to leave.

## A Man of Earth and Mind

Despite his calloused hands and work clothes, Aryeh was also a man of books - deeply knowledgeable about history and the geography of Israel. The kibbutz remembered him as "an honest and humble worker, an idealist and a farmer at heart and soul."

He was married to Ruth, who passed away in 1997, and was father to two sons, Boaz and Yoav, and grandfather to five grandchildren.

## October 7, 2023

On that terrible morning, Aryeh sheltered in his safe room. At 9:26 a.m., he managed to text his son that terrorists had infiltrated the kibbutz - his last direct communication with family. When terrorists found him, they beat him with a stick, wounding his head and hand. At 85, he was the oldest of approximately 240 people kidnapped that day.

Footage emerged of him being driven into Gaza on the back of a motorcycle, bleeding and wounded, without his glasses or hearing aid.

## Final Days

Aryeh spent approximately 40 days in captivity with fellow hostage Farhan al-Qadi. Despite suffering from diabetes, he received no proper medication or care. His health deteriorated until he stopped eating and speaking.

Farhan later recalled: "On the day he died, he managed to say goodbye to everyone. He said goodbye to the kibbutz, his friends and his granddaughter, whom he loved. He died at midnight."

Aryeh died on November 17, 2023 - murdered, as his son Boaz said, "by torment of the body and mind."

## Coming Home

After 746 days, Aryeh's remains were returned to Israel on October 21, 2025. The man who had devoted his life to making the desert bloom, who saw the kibbutz as the fulfillment of his life's mission, was finally laid to rest in the soil he had worked for six decades.

His son spoke at a hostages rally: "He sees the kibbutz as his life's mission. The community as his family. Even dying in the house he built with his own hands, alongside the fields he toiled over - they didn't let him die there."

*We will remember Zalman as an honest and humble worker, an idealist and a farmer at heart and soul. May his memory be a blessing.*

[Read more about Aryeh Zalmanovich](https://www.timesofisrael.com/son-says-aryeh-zalmanovich-86-was-murdered-in-gaza-hospital-next-to-farhan-al-qadi/)
`
};
